export const API = 'PAYMENT_TYPE_API';
export const HOSTED = 'PAYMENT_TYPE_HOSTED';
export const OFFLINE = 'PAYMENT_TYPE_OFFLINE';
export const SDK = 'PAYMENT_TYPE_SDK';
